// @ts-ignore
import { isWebpSupported } from 'react-image-webp/dist/utils'

import pressImgJpg_0 from 'assets/images/press_0.jpg'

import pressImgJpg_1 from 'assets/images/press_1.jpg'
import pressImgJpg_2 from 'assets/images/press_2.jpg'
import pressImgJpg_4 from 'assets/images/press_4.jpg'
import pressImgJpg_5 from 'assets/images/press_5.jpg'
import pressImgJpg_6 from 'assets/images/press_6.jpg'

import pressImgWebp_1 from 'assets/images/press_1.webp'
import pressImgWebp_2 from 'assets/images/press_2.webp'
import pressImgWebp_5 from 'assets/images/press_5.webp'
import pressImgWebp_6 from 'assets/images/press_6.webp'

const pressImg_0 = pressImgJpg_0

const pressImg_1 = isWebpSupported() ? pressImgWebp_1 : pressImgJpg_1

const pressImg_2 = isWebpSupported() ? pressImgWebp_2 : pressImgJpg_2

const pressImg_3 = pressImgJpg_4

const pressImg_5 = isWebpSupported() ? pressImgWebp_5 : pressImgJpg_5

const pressImg_6 = isWebpSupported() ? pressImgWebp_6 : pressImgJpg_6

const ARTICLES_LIST = [
  {
    id: '0',
    title: '11 лучших кондитеров в России и 12 вау-идей свадебного торта',
    previewSrc: pressImg_6,
    link: 'https://www.wedding-magazine.ru/wedding-day/11-luchshih-konditerov-v-rossii-i-12-idej-svadebnogo-torta',
  },
  {
    id: '1',
    title:
      'Cake Buro — победители Wedding Awards Russia 2026 в номинации «Лучший свадебный кондитер»',
    previewSrc: pressImg_5,
    link: 'https://www.wedding-magazine.ru/wedding-day/luchshie-svadebnye-specilisty-v-rossii-wedding-awards-2026',
  },
  {
    id: '2',
    title: 'Торт в форме игрушки Labubu от Cake Buro',
    previewSrc: pressImg_3,
    link: 'https://t-j.ru/labubutort/',
  },
  {
    id: '3',
    title: 'Елена Железнякова — победительница голосования «Да, шеф! Women»',
    previewSrc: pressImg_0,
    link: 'https://www.restorating.ru/sch/articles/da-chief-msk-2022-final',
  },
  {
    id: '4',
    title:
      'Десерты, которые вас удивят. Шеф-кондитер «Кофемании» Елена Железнякова о трендах в кондитерском деле',
    previewSrc: pressImg_1,
    link: 'https://www.gastronom.ru/text/shef-konditer-kofemanii-elena-shakarjan-o-trendah-1013649',
  },
  {
    id: '5',
    title:
      'Елена Железнякова: «Я ни с кем не соревнуюсь, я просто делаю свою работу»',
    previewSrc: pressImg_2,
    link: 'http://www.horeca-magazine.ru/article/8211/',
  },
]

export default ARTICLES_LIST
